import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {errorlist} from '../providers/errorlist';
import { ResetPassword } from '../models/user';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';

@Component({
  selector: 'app-driver-reset-password',
  templateUrl: './driver-reset-password.component.html',
  styleUrls: ['./driver-reset-password.component.css']
})
export class DriverResetPasswordComponent implements OnInit {
  type2 = "password";
  type3 = "password";
  errorlist:any;
  private sub:any ="";
  token: any = "";
  public userData:ResetPassword = {password: null, cnfpassword: null, token: null};
  constructor(private auth : AuthService, private router: Router, private route: ActivatedRoute, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.errorlist = errorlist;
    this.sub = this.route.params.subscribe(params => {
      this.token = params['token']; // (+) converts string 'id' to a number

      this.spinnerService.show();
      this.userData['token'] = this.token;
      console.log(this.userData)
      this.auth.check_driver_reset_password({"token":this.token}).then((user) => {
        console.log(user.json());
        let response = user.json();
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          this.spinnerService.hide();
          if(response.token == false){
            this.router.navigate(['/']);
          }
        }
      })
      .catch((err) => {
        this.spinnerService.hide();
        console.log(err);
        this.auth.open(environment.error)
      });
    });
  }

  togglePassword(type, nameVariable){
    if (type == "password"){
      this[nameVariable] = "text";
    }
    else {
      this[nameVariable] = "password";
    }
  }

  changepasswordUser(){
    console.log(this.userData)
    this.sub = this.route.params.subscribe(params => {
      this.token = params['token']; // (+) converts string 'id' to a number

      this.spinnerService.show();
      this.userData['token'] = this.token;
      console.log(this.userData)
      this.auth.driver_reset_password(this.userData).then((user) => {
        console.log(user.json());
        let response = user.json();
        if(response.replyCode == "error"){
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
        }else{
          this.userData = {};
          this.spinnerService.hide();
          this.auth.open(response.replyMsg);
          this.router.navigate(['/']);
        }
      })
      .catch((err) => {
        this.spinnerService.hide();
        console.log(err);
        this.auth.open(environment.error)
      });
    });
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/driver-reset-password/driver-reset-password.component.ts